import { render, staticRenderFns } from "./SickDayLegend.vue?vue&type=template&id=d63a4896&"
import script from "./SickDayLegend.vue?vue&type=script&lang=js&"
export * from "./SickDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports